import React from 'react';

import Button from '../buttons/Button';

function PoiSuggestionError() {
    return (
        <div>
            <div className="mb-12 text-center">
                <h1 className="text-danger">Pri nalaganju točke je šlo nekaj narobe.</h1>
                <p className="my-8 max-w-xl mx-auto">
                    Preveri, da fotografije niso prevelike in da ustrezajo formatu .png ali .jpg. Preveri tudi, da imaš
                    stabilno internetno povezavo (WiFi) potem pa osveži stran in poskusi znova.
                </p>
                <div className="mt-6 text-center flex gap-8 justify-center">
                    <Button link="/kontakt" variant="outlined" color="secondary">
                        Sporoči nam težavo
                    </Button>
                    <Button variant="contained" color="secondary" onClick={() => window.location.reload()}>
                        Osveži stran in poskusi znova
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default PoiSuggestionError;
